import { render, staticRenderFns } from "./403.vue?vue&type=template&id=bd1ad08c&scoped=true"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"
import style0 from "./403.vue?vue&type=style&index=0&id=bd1ad08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1ad08c",
  null
  
)

export default component.exports